import React from "react";
import { Integration } from "/app/src/models";
import GeneralSettings from "/app/src/components/apps/orderBuilder/settings/generalSettings";
import Fields from "./fields";
import OrderBuilderStatuses from "../../../settings/app/orderBuilder";
import ManualOrderFields from "./fields/manualOrderFields";
import IntegrationSetting from "./integrationSettings";
import GenericSettings from "./genericSettings";
/**
 * Component to display the settings for a single Data Pull or Data Push Integration
 */
export default function Settings({
  integration,
}: {
  integration: Integration;
}) {
  return (
    <>
      {integration?.number === "manual" && (
        <>
          <IntegrationSetting integration={integration} />
          <GenericSettings integration={integration} />
          <ManualOrderFields integration={integration} />
        </>
      )}
      {integration?.number === "automatic" && (
        <>
          <GeneralSettings integration={integration} />
          <Fields integration={integration} />
        </>
      )}

      <OrderBuilderStatuses integration={integration} />
    </>
  );
}
